/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var mirai = {
    // All pages
    'common': {
      init: function() {

		$('.mobile-trigger').click(function() {
			$(this).find('span').toggleClass('active');
			$('nav.nav-mobile').slideToggle();
		});

		$('#primary-menu li').click(function() {
		    var $this = $(this),
		        $ul   = $('ul', this);
		    
		    if (!$ul.hasClass('active')) {
		        $('.active', '#primary-menu').removeClass('active');
				$ul.stop().addClass('active').slideDown();
		        $this.find("ul li a").stop().addClass('animated fadeInDown');
		    } else {
		        $ul.removeClass('active').slideUp();
		    }
		});

		// Create a psuedo slideshow if their is more than one image on the fullwidth module

		var _intervalId;

		function fadeInLastImg() {
			var backImg = $('.module__fullwidth__images--gallery img:first');
			backImg.hide();
			$('.module__fullwidth__images--gallery' ).append( backImg );
			backImg.fadeIn()
		};

		_intervalId = setInterval( function() {
			fadeInLastImg();
		}, 6000 );

		// Sliders
		$('.module__slider').owlCarousel({
			navigation : true, // Show next and prev buttons
			slideSpeed : 300,
			paginationSpeed : 400,
			singleItem:true,
			transitionStyle : "fade"
		});

		$('.module__gallery__slider').owlCarousel({
			autoPlay: 3000, //Set AutoPlay to 3 seconds
			items : 4,
			itemsDesktop : [1199,3],
			itemsDesktopSmall : [979,3]
		});

		$(".fancybox").fancybox({
			openEffect	: 'none',
			closeEffect	: 'none'
		});

      },
      finalize: function() {

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'gallery': {
    	init: function() {
	        $('.gallery__content').mixItUp();
        	$('.gallery__content').on('mixStart', function(e, state){
        		console.log(state);
        		$('html, body').animate({
    		        scrollTop: $(".gallery__content").offset().top
    		    }, 1000);
        	});
    	}

    	
    },
    // Contat us page
    'contact_us': {
    	init: function() {
    		/*
			*  new_map
			*
			*  This function will render a Google Map onto the selected jQuery element
			*
			*  @type	function
			*  @date	8/11/2013
			*  @since	4.3.0
			*
			*  @param	$el (jQuery element)
			*  @return	n/a
			*/

			function new_map( $el ) {
				
				// var
				var $markers = $el.find('.marker');
				
				
				// vars
				var args = {
					zoom		: 16,
					center		: new google.maps.LatLng(0, 0),
					mapTypeId	: google.maps.MapTypeId.ROADMAP,
					draggable: true,
					gestureHandling: 'cooperative'
				};
				
				
				// create map	        	
				var map = new google.maps.Map( $el[0], args);
				
				
				// add a markers reference
				map.markers = [];
				
				
				// add markers
				$markers.each(function(){
					
			    	add_marker( $(this), map );
					
				});
				
				
				// center map
				center_map( map );
				
				
				// return
				return map;
				
			}

			/*
			*  add_marker
			*
			*  This function will add a marker to the selected Google Map
			*
			*  @type	function
			*  @date	8/11/2013
			*  @since	4.3.0
			*
			*  @param	$marker (jQuery element)
			*  @param	map (Google Map object)
			*  @return	n/a
			*/

			function add_marker( $marker, map ) {

				// var
				var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

				// create marker
				var marker = new google.maps.Marker({
					position	: latlng,
					map			: map,
					icon: '../cms/wp-content/themes/Roger%20Elliot/dist/images/location-icon.png',
				});

				/*
				var template6 = [
					'<svg width="35" height="35" viewBox="0 0 35 35" xmlns="http://www.w3.org/2000/svg">',
					'<circle fill="{{ color }}" cx="17.5" cy="17.5" r="17.5"/>',
					'<path d="M7.432 20.22c0 2.754 1.998 3.996 3.96 3.996 1.98 0 3.996-1.206 3.996-3.996v-9H9.772v1.998h3.294v6.966c0 1.386-.774 1.908-1.638 1.908-.864 0-1.692-.504-1.692-2.016v-.594H7.432v.738zm15.3 3.996c2.538 0 4.212-1.908 4.212-4.284 0-2.304-1.584-4.266-4.104-4.266-.918 0-1.944.378-2.394.9h-.036c.324-1.746 1.386-3.42 3.402-3.42.99 0 1.8.396 1.8.396l.684-1.998s-.99-.54-2.61-.54c-3.96 0-5.886 3.798-5.886 7.146 0 3.852 2.268 6.066 4.932 6.066zm0-2.124c-1.35 0-2.52-1.53-2.52-3.132 0-.792.936-1.386 2.088-1.386 1.53 0 2.34 1.062 2.34 2.358 0 1.206-.72 2.16-1.908 2.16z" fill="{{ fill }}"/>',
					'</svg>'
				].join('\n');

				var svg6 = template6.replace('{{ color }}', '#444').replace('{{ fill }}', '#fff');		

				var marker6 = new google.maps.Marker({
					position: new google.maps.LatLng(51.258406, -0.072736),
					map: map,

					title: 'Junction 6',
					icon: {
						anchor: new google.maps.Point(17, 17),
						url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg6)
					}
				});
				*/
				
				var marker6Image = {
					url: "../cms/wp-content/themes/Roger%20Elliot/dist/images/junction_marker_6.png",
					size: new google.maps.Size(50, 50),
					anchor: new google.maps.Point(12, 12),
					scaledSize: new google.maps.Size(25, 25)
				};
				var marker7Image = {
					url: "../cms/wp-content/themes/Roger%20Elliot/dist/images/junction_marker_7.png",
					size: new google.maps.Size(50, 50),
					anchor: new google.maps.Point(12, 12),
					scaledSize: new google.maps.Size(25, 25)
				};
				var marker8Image = {
					url: "../cms/wp-content/themes/Roger%20Elliot/dist/images/junction_marker_8.png",
					size: new google.maps.Size(50, 50),
					anchor: new google.maps.Point(12, 12),
					scaledSize: new google.maps.Size(25, 25)
				};
				
				// var marker6Image = new google.maps.MarkerImage("../cms/wp-content/themes/Roger%20Elliot/dist/images/junction_marker_6.png", null, null, null, new google.maps.Size(35,35));

				var marker6 = new google.maps.Marker({
					position: new google.maps.LatLng(51.258947, -0.064204),
					map: map,
					title: 'Junction 6',
					icon: marker6Image
				});
				var marker7 = new google.maps.Marker({
					position: new google.maps.LatLng(51.263972, -0.127839),
					map: map,
					title: 'Junction 7',
					icon: marker7Image
				});
				/*
				var marker7a = new google.maps.Marker({
					position: new google.maps.LatLng(51.265125, -0.140485),
					map: map,
					title: 'Junction 7',
					icon: marker7Image
				});
				*/
				var marker8 = new google.maps.Marker({
					position: new google.maps.LatLng(51.258670, -0.198060),
					map: map,
					title: 'Junction 8',
					icon: marker8Image
				});

				


				// add to array
				map.markers.push( marker );

				// if marker contains HTML, add it to an infoWindow
				if( $marker.html() )
				{
					// create info window
					var infowindow = new google.maps.InfoWindow({
						content		: $marker.html()
					});

					// show info window when marker is clicked
					google.maps.event.addListener(marker, 'click', function() {

						infowindow.open( map, marker );

					});
				}

			}

			/*
			*  center_map
			*
			*  This function will center the map, showing all markers attached to this map
			*
			*  @type	function
			*  @date	8/11/2013
			*  @since	4.3.0
			*
			*  @param	map (Google Map object)
			*  @return	n/a
			*/

			function center_map( map ) {

				// vars
				var bounds = new google.maps.LatLngBounds();

				// loop through all markers and create bounds
				$.each( map.markers, function( i, marker ){

					var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

					bounds.extend( latlng );

				});

				// only 1 marker?
				if( map.markers.length == 1 )
				{
					// set center of map
				    map.setCenter( bounds.getCenter() );
				    map.setZoom( 12 );
				}
				else
				{
					// fit to bounds
					map.fitBounds( bounds );
				}

			}

			/*
			*  document ready
			*
			*  This function will render each map when the document is ready (page has loaded)
			*
			*  @type	function
			*  @date	8/11/2013
			*  @since	5.0.0
			*
			*  @param	n/a
			*  @return	n/a
			*/
			// global var
			var map = null;

			$('.acf-map').each(function(){
				// create map
				map = new_map( $(this) );
			});
    	}
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = mirai;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
